import { auth } from './firebase';

// Sign In
export const doSignInWithEmailAndPassword = (email, password) =>
  auth.signInWithEmailAndPassword(email, password);

// Sign out
export const doSignOut = () => auth.signOut();



// WEBPACK FOOTER //
// ./src/firebase/auth.js